export default __webpack_public_path__ + "static/media/user2.a6837091.png";